import React from 'react';

export default function PriorityHighIcon() {
  return (
    <svg width="40" height="37" viewBox="0 0 40 37" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="37" rx="7" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M19.9731 7C17.5836 7 15.7349 9.09424 16.0313 11.4653L17.3914 22.3464C17.445 22.7754 17.6047 23.1842 17.8559 23.536C18.8936 24.9887 21.0526 24.9887 22.0903 23.536C22.3415 23.1842 22.5012 22.7754 22.5548 22.3464L23.9149 11.4653C24.2113 9.09424 22.3626 7 19.9731 7ZM19.9731 31C21.3538 31 22.4731 29.8807 22.4731 28.5C22.4731 27.1193 21.3538 26 19.9731 26C18.5924 26 17.4731 27.1193 17.4731 28.5C17.4731 29.8807 18.5924 31 19.9731 31Z" fill="white" />
    </svg>
  );
}
